/* eslint-disable no-restricted-globals */
import React, { useState, useEffect } from "react"
import {
  Button,
  Modal,
  Card,
  Input,
  Dimmer,
  Loader,
  Select,
  TextArea,
} from "semantic-ui-react"
import { useTranslation } from "react-i18next"

const optionsM = [{ key: 0, value: "PKCS12", text: "PKCS12" }]

const webSocket = new WebSocket("wss://127.0.0.1:13579/")
let callback = null

const ECPSignatureComponent = (props) => {
  const { t } = useTranslation()
  const { getXmlData } = props
  const [modal, setModal] = useState(false)
  const [step, setStep] = useState(0)
  const [storageSelect, setStorageSelect] = useState(optionsM[0].value)
  const [options, setOptions] = useState(optionsM)
  const [alias, setAlias] = useState("")
  const [keyId, setKeyId] = useState("")
  const [algorithm, setAlgorithm] = useState("")
  const [subjectCN, setSubjectCN] = useState("")
  const [subjectDN, setSubjectDN] = useState("")
  const [issuerCN, setIssuerCN] = useState("")
  const [issuerDN, setIssuerDN] = useState("")
  const [serialNumber, setSerialNumber] = useState("")
  const [NotBefore, setNotBefore] = useState("")
  const [NotAfter, setNotAfter] = useState("")
  const [authorityKeyIdentifier, setAuthorityKeyIdentifier] = useState("")
  const [pem, setPem] = useState("")
  // const [xmlToSign, setXmlToSign] = useState("")
  const [xmlToSign1, setXmlToSign1] = useState("")
  const [xmlToSign2, setXmlToSign2] = useState("")
  const [signedXml, setSignedXml] = useState("")
  const [signedXml1, setSignedXml1] = useState("")
  const [signedXml2, setSignedXml2] = useState("")
  const [filePath, setFilePath] = useState("")
  const [createdCMS, setCreatedCMS] = useState("")
  const [base64ToSign, setBase64ToSign] = useState("")
  const [createdCMSforBase64, setCreatedCMSforBase64] = useState("")
  const [createdCMSforBase64Hash, setCreatedCMSforBase64Hash] = useState("")
  const [CMSForTS, setCMSForTS] = useState("")
  const [localeSelect, setLocaleSelect] = useState("")
  const [flag, setFlag] = useState(false)
  const [flagForBase64, setFlagForBase64] = useState(false)
  const [createdCMSWithAppliesTS, setCreatedCMSWithAppliesTS] = useState(false)
  const steps = [
    <>
      <div>
        Выберите необходимый тип носителя
        <Input
          value="Добавить доступные токены"
          onClick={() => {
            getActiveTokensCall()
          }}
          type="button"
        />
        <p></p>
        <Select
          options={options}
          value={storageSelect}
          onChange={(e, d) => {
            storageSelect(d.value)
          }}
          fluid
        />
        <h2>1. Данные ключа</h2>
        <Input
          value="Получить данные ключа"
          onClick={() => {
            getKeyInfoCall()
          }}
          type="button"
        />
        <div style={{ marginBottom: 10 }}>
          <label style={{ width: "20vw", display: "inline-block" }}>
            Алиас ключа:
          </label>
          <div style={{ width: "70vw", display: "inline-block" }}>
            <Input type="text" value={alias} disabled fluid />
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ width: "20vw", display: "inline-block" }}>
            Идентификатор ключа:
          </label>
          <div style={{ width: "70vw", display: "inline-block" }}>
            <Input class="form-control" type="text" value={keyId} fluid />
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ width: "20vw", display: "inline-block" }}>
            Алгоритм ключа:
          </label>
          <div style={{ width: "70vw", display: "inline-block" }}>
            <Input type="text" value={algorithm} fluid disabled />
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ width: "20vw", display: "inline-block" }}>
            Общепринятое имя субъекта:
          </label>
          <div style={{ width: "70vw", display: "inline-block" }}>
            <Input type="text" value={subjectCN} fluid disabled />
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ width: "20vw", display: "inline-block" }}>
            Уникальное имя субъекта:
          </label>
          <div style={{ width: "70vw", display: "inline-block" }}>
            <Input type="text" value={subjectDN} fluid disabled />
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ width: "20vw", display: "inline-block" }}>
            Общепринятое имя издателя:
          </label>
          <div style={{ width: "70vw", display: "inline-block" }}>
            <Input type="text" value={issuerCN} fluid disabled />
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ width: "20vw", display: "inline-block" }}>
            Уникальное имя издателя:
          </label>
          <div style={{ width: "70vw", display: "inline-block" }}>
            <Input type="text" value={issuerDN} fluid disabled />
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ width: "20vw", display: "inline-block" }}>
            Серийный номер сертификата:
          </label>
          <div style={{ width: "70vw", display: "inline-block" }}>
            <Input type="text" value={serialNumber} fluid disabled />
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ width: "20vw", display: "inline-block" }}>
            Дата начала действия сертификата:
          </label>
          <div style={{ width: "70vw", display: "inline-block" }}>
            <Input type="text" value={NotBefore} fluid disabled />
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ width: "20vw", display: "inline-block" }}>
            Дата окончания действия сертификата:
          </label>
          <div style={{ width: "70vw", display: "inline-block" }}>
            <Input type="text" value={NotAfter} disabled fluid />
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ width: "20vw", display: "inline-block" }}>
            Идентификатор ключа УЦ:
          </label>
          <div style={{ width: "70vw", display: "inline-block" }}>
            <Input type="text" value={authorityKeyIdentifier} disabled fluid />
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ width: "20vw", display: "inline-block" }}>
            Сертификат в формате PEM:
          </label>
          <div style={{ width: "70vw", display: "inline-block" }}>
            <TextArea value={pem} rows="3" readOnly style={{ width: "70vw" }} />
          </div>
        </div>
      </div>
    </>,
    <>
      <div></div>
    </>,
    <>
      <div></div>
    </>,
  ]
  const closeModal = () => {
    setModal(false)
  }
  const openDialog = () => {
    if (
      confirm(
        "Ошибка при подключение к NCALayer. Запустите NCALayer и нажмите OK",
      ) === true
    ) {
      location.reload()
    }
  }
  const blockScreen = () => {
    /* $.blockUI({
      message:
        '<img src="js/loading.gif" /><br/>Подождите, выполняется операция в NCALayer...',
      css: {
        border: "none",
        padding: "15px",
        backgroundColor: "#000",
        "-webkit-border-radius": "10px",
        "-moz-border-radius": "10px",
        opacity: 0.5,
        color: "#fff",
      },
    }) */
  }
  const getActiveTokens = (callbackM) => {
    let getActiveTokens = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "getActiveTokens",
    }
    callback = callbackM
    webSocket.send(JSON.stringify(getActiveTokens))
  }
  const getActiveTokensCall = () => {
    blockScreen()
    getActiveTokens(getActiveTokensBack)
  }
  const unblockScreen = () => {
    // $.unblockUI()
  }
  const getActiveTokensBack = (result) => {
    unblockScreen()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let listOfTokens = result["responseObject"]
      const temp = []
      temp.push({ text: "PKCS12", value: "PKCS12" })
      for (let i = 0; i < listOfTokens.length; i++) {
        temp.push({ text: listOfTokens[i], value: listOfTokens[i] })
      }
      setStorageSelect(temp)
    }
  }
  const getKeyInfoCall = () => {
    blockScreen()
    getKeyInfoCall(storageSelect, getKeyInfoBack)
  }
  const getKeyInfoBack = (result) => {
    unblockScreen()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      console.log(res)
      let res = result["responseObject"]
      let dateString = res["certNotAfter"]
      let date = new Date(Number(dateString))
      let dateString1 = res["certNotBefore"]
      let date1 = new Date(Number(dateString1))
      setAlias(res["alias"])
      setKeyId(res["keyId"])
      setAlgorithm(res["algorithm"])
      setSubjectCN(res["subjectCn"])
      setSubjectDN(res["subjectDn"])
      setIssuerCN(res["issuerCn"])
      setIssuerDN(res["issuerDn"])
      setSerialNumber(res["serialNumber"])
      setNotBefore(date1.toLocaleString())
      setNotAfter(date.toLocaleString())
      setAuthorityKeyIdentifier(res["authorityKeyIdentifier"])
      setPem(res["pem"])
    }
  }
  const getKeyInfo = (storageName, callbackM) => {
    let getKeyInfo = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "getKeyInfo",
      args: [storageName],
    }
    callback = callbackM
    webSocket.send(JSON.stringify(getKeyInfo))
  }
  const signXmlCall = (res) => {
    blockScreen()
    const xts = res
      .replaceAll('<?xml version="1.0" encoding="UTF-8"?>\n', "")
      .replaceAll(
        "<!--Sample XML file generated by XMLSpy v2020 rel. 2 sp1 (x64) (http://www.altova.com)-->\n",
        "",
      )
    console.log(res)
    console.log(xts)
    signXml(storageSelect, "SIGNATURE", xts, signXmlBack)
  }
  const signXmlBack = (result) => {
    unblockScreen()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      setSignedXml(res)
      let blob = new Blob([res], {
        type: "text/xml",
      })
      let url = URL.createObjectURL(blob)
      window.open(url)
      URL.revokeObjectURL(url)
    }
  }
  const signXml = (storageName, keyType, xmlToSign, callBackM) => {
    let signXml = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "signXml",
      args: [storageName, keyType, xmlToSign, "", ""],
    }
    callback = callBackM
    webSocket.send(JSON.stringify(signXml))
  }
  const signXmlsCall = () => {
    // eslint-disable-next-line no-array-constructor
    let xmlsToSign = new Array(xmlToSign1, xmlToSign2)
    blockScreen()
    signXmls(storageSelect, "SIGNATURE", xmlsToSign, signXmlsBack)
  }
  const signXmlsBack = (result) => {
    unblockScreen()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      setSignedXml(res[0])
      setSignedXml2(res[1])
    }
  }
  const signXmls = (storageName, keyType, xmlsToSign, callBackM) => {
    let signXmls = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "signXmls",
      args: [storageName, keyType, xmlsToSign, "", ""],
    }
    callback = callBackM
    webSocket.send(JSON.stringify(signXmls))
  }
  const showFileChooserCall = () => {
    blockScreen()
    showFileChooser("ALL", "", showFileChooserBack)
  }
  const showFileChooserBack = (result) => {
    unblockScreen()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      setFilePath(res)
    }
  }
  const showFileChooser = (fileExtension, currentDirectory, callBackM) => {
    let showFileChooser = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "showFileChooser",
      args: [fileExtension, currentDirectory],
    }
    callback = callBackM
    webSocket.send(JSON.stringify(showFileChooser))
  }
  const createCAdESFromFileCall = () => {
    if (filePath !== null && filePath !== "") {
      blockScreen()
      createCAdESFromFile(
        storageSelect,
        "SIGNATURE",
        filePath,
        flag,
        createCAdESFromFileBack,
      )
    } else {
      alert("Не выбран файл для подписи!")
    }
  }
  const createCAdESFromFile = (
    storageName,
    keyType,
    filePath,
    flag,
    callBackM,
  ) => {
    let createCAdESFromFile = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "createCAdESFromFile",
      args: [storageName, keyType, filePath, flag],
    }
    callback = callBackM
    webSocket.send(JSON.stringify(createCAdESFromFile))
  }
  const createCAdESFromFileBack = (result) => {
    unblockScreen()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      setCreatedCMS(res)
    }
  }
  const createCAdESFromBase64Call = (res) => {
    const xts = res
      .replaceAll('<?xml version="1.0" encoding="UTF-8"?>\n', "")
      .replaceAll(
        "<!--Sample XML file generated by XMLSpy v2020 rel. 2 sp1 (x64) (http://www.altova.com)-->\n",
        "",
      )
    console.log(xts)
    const b64tsgn = b64EncodeUnicode(xts)
    if (b64tsgn !== null && b64tsgn !== "") {
      // $.blockUI()
      createCAdESFromBase64(
        storageSelect,
        "SIGNATURE",
        b64tsgn,
        flagForBase64,
        createCAdESFromBase64Back,
      )
    } else {
      alert("Нет данных для подписи!")
    }
  }
  const b64EncodeUnicode = (str) => {
    return btoa(
      encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
          return String.fromCharCode("0x" + p1)
        },
      ),
    )
  }
  const b64DecodeUnicode = (str) => {
    return decodeURIComponent(
      atob(str)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join(""),
    )
  }
  const createCAdESFromBase64Back = (result) => {
    // $.unblockUI()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      console.log(res.replaceAll(base64ToSign, ""))
      const s = b64DecodeUnicode(res)
      const a = s.indexOf("<file")
      const b = s.indexOf("</file>")
      const cut = s.slice(a, b + 7)
      const r = s.replaceAll(cut, "")
      console.log(r)
      console.log(b64EncodeUnicode(r))
      setCreatedCMSforBase64(res)
    }
  }
  const createCAdESFromBase64 = (
    storageName,
    keyType,
    base64ToSign,
    flag,
    callBackM,
  ) => {
    let createCAdESFromBase64 = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "createCAdESFromBase64",
      args: [storageName, keyType, base64ToSign, true],
    }
    callback = callBackM
    webSocket.send(JSON.stringify(createCAdESFromBase64))
  }
  const createCAdESFromBase64HashCall = () => {
    if (base64ToSign !== null && base64ToSign !== "") {
      // $.blockUI()
      createCAdESFromBase64Hash(
        storageSelect,
        "SIGNATURE",
        base64ToSign,
        createCAdESFromBase64HashBack,
      )
    } else {
      alert("Нет данных для подписи!")
    }
  }
  const createCAdESFromBase64HashBack = (result) => {
    // $.unblockUI()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      setCreatedCMSforBase64Hash(res)
    }
  }
  const createCAdESFromBase64Hash = (
    storageName,
    keyType,
    base64ToSign,
    callBackM,
  ) => {
    let createCAdESFromBase64Hash = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "createCAdESFromBase64Hash",
      args: [storageName, keyType, base64ToSign],
    }
    callback = callBackM
    webSocket.send(JSON.stringify(createCAdESFromBase64Hash))
  }
  const applyCAdESTCall = () => {
    if (CMSForTS !== null && CMSForTS !== "") {
      // $.blockUI()
      applyCAdEST(storageSelect, "SIGNATURE", CMSForTS, applyCAdESTBack)
    } else {
      alert("Нет данных для подписи!")
    }
  }
  const applyCAdESTBack = (result) => {
    // $.unblockUI()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      let res = result["responseObject"]
      setCreatedCMSWithAppliesTS(res)
    }
  }
  const applyCAdEST = (storageName, keyType, cmsForTS, callBackM) => {
    let applyCAdEST = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "applyCAdEST",
      args: [storageName, keyType, cmsForTS],
    }
    callback = callBackM
    webSocket.send(JSON.stringify(applyCAdEST))
  }
  const changeLocaleCall = () => {
    changeLocale(localeSelect)
  }
  const changeLocale = (language) => {
    let changeLocale = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "changeLocale",
      args: [language],
    }
    callback = null
    webSocket.send(JSON.stringify(changeLocale))
  }
  const renderStep = () => {
    return (
      <>
        <Modal
          open={modal}
          onClose={closeModal}
          style={{ marginTop: "-40vh", height: "max-content" }}
        >
          <Card fluid>
            <Card.Content>{steps[step]}</Card.Content>
          </Card>
        </Modal>
      </>
    )
  }
  useEffect(() => {
    webSocket.onopen = (event) => {
      //
    }
    webSocket.onclose = (event) => {
      if (event.wasClean) {
        console.log("connection has benn closed")
      } else {
        console.log("Connection error")
        openDialog()
      }
      console.log("Code:" + event.code + " Reason: " + event.reason)
    }
    webSocket.onmessage = (event) => {
      let result = JSON.parse(event.data)
      console.log(result)
      if (result != null) {
        let rw = {
          code: result["code"],
          message: result["message"],
          responseObject: result["responseObject"],
          getResult: () => {
            return this.result
          },
          getMessage: () => {
            return this.message
          },
          getResponseObject: () => {
            return this.responseObject
          },
          getCode: () => {
            return this.code
          },
        }
        if (callback != null) {
          callback(rw)
        }
      }
      //console.log(event)
    }
  }, [])
  return (
    <>
      {renderStep()}
      <Button
        positive
        content={t("signWithEcp")}
        onClick={() => {
          getXmlData(createCAdESFromBase64Call)
          // setModal(true)
        }}
      />
    </>
  )
}

export default ECPSignatureComponent
